import _ from 'underscore';
import {SYSTEM_ATTRIBUTE_LABELS} from '../locales';
import {type IAttributeTemplate} from '../schema';

export const getLabel = (attr: IAttributeTemplate, escape = false) => {
	const label = attr.system
		? SYSTEM_ATTRIBUTE_LABELS[attr.attributeid] ?? i18n.t(`i18n.${attr.name}`)
		: attr.name;

	return escape ? _.escape(label) : label;
};

export default getLabel;
